//index.js
import Repository from '../../../repositories/RepositoryFactory';
const UserAccountRepository = Repository.get('userAccounts');

// AxiosClient never rejects: transport failures come back as { error } and business failures come
// back as an ApiResult with success === false. Normalise both into a thrown Error so callers can
// use a plain then/catch, and so the message shown to the administrator is the API's own wording.
function unwrap(response, fallbackMessage) {
  if (!response || response.error || !response.data) {
    throw new Error(
      'Could not reach the server. Please check your connection and try again.',
    );
  }

  const payload = response.data;

  if (payload.success !== true) {
    const details = (payload.errorMessages || [])
      .map((x) => x.message)
      .filter((x) => x);

    throw new Error(
      details.length > 0
        ? details.join(' ')
        : payload.errorMessage || fallbackMessage,
    );
  }

  return payload;
}

export default {
  changePassword: async (
    { commit },
    { primeUserId, newPassword, confirmPassword },
  ) => {
    const response = await UserAccountRepository.changePassword({
      primeUserId,
      newPassword,
      confirmPassword,
    });

    const payload = unwrap(response, 'The password could not be changed.');

    commit('SET_lastOperation', payload.result);

    return payload;
  },

  revokeSessions: async ({ commit }, { primeUserId }) => {
    const response = await UserAccountRepository.revokeSessions({ primeUserId });

    const payload = unwrap(response, 'The sessions could not be revoked.');

    commit('SET_lastOperation', payload.result);

    return payload;
  },
};
